module.exports = __webpack_public_path__ + "media/images/lb/892-9c824e55db5d8c3e192f507e41584614.svg";